<template>
  <div class="monitoring-card__badge" :class="`${badgeData.type || ''}`">
    <VDropdown theme="badge-popper" container=".psc" placement="top" :disabled="typeof badgeData.tooltipText != 'string'" :triggers="['hover']" :popper-triggers="['hover']">
      <span>{{ badgeData.title }}</span><i v-if="badgeData.tooltipText" class="mdi mdi-information-outline"></i>
      <template #popper>
        {{ badgeData.tooltipText }}
      </template>
    </VDropdown>
  </div>
</template>

<script>
export default {
  name: "CardBadge",
  props: ['badgeData']
}
</script>

<style scoped lang="scss">
.monitoring-card__badge {
  background: #424242;
  &.is-error {
    background: #c0392b;
  }
  &.is-info {
    background: $blue;
  }
  &.is-warning {
    background: #dbaf00;
  }
  &.is-success {
    background: $green;
  }
  position: absolute;
  top: -14px;
  padding: 2px 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: auto;
  right: 0;
  left: 0;
  text-align: center;
  display: flex;
  align-items: center;
  width: 70%;
  cursor: help;
  line-height: 8px;
  :deep(.v-popper) {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      padding-top: 1px;
      font-size: 9px;
      font-weight: 600;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      color: #fff;
    }
  }
  i {
    font-size: 12px;
    color: #fff;
    margin-top: 1px;
    margin-left: 5px;
  }
}
</style>
